import { MenuItem } from 'primereact/menuitem';
import { PanelMenu } from 'primereact/panelmenu';
import { Dispatch, FC, SetStateAction, useState } from 'react';
import PanelMenuCheckboxTemplate from './PanelMenuCheckboxTemplate';
import { SelectedRoadmap } from './SettingsTabRoadmaps';
import PanelMenuHeaderTemplate from './PanelMenuHeaderTemplate';

interface Site {
  id: string;
  name: string;
  availableTargetGroupGroupedByStandardGrade:
    | {
        id: string;
        name: string | null | undefined;
        targetGroup: {
          id: string;
          name: string | null | undefined;
        }[];
      }[]
    | [];
}

interface Props {
  site: Site;
  selectedRoadmap: SelectedRoadmap;
  setSelectedRoadmaps: Dispatch<SetStateAction<SelectedRoadmap[]>>;
}

const PanelMenuRoadmaps: FC<Props> = ({ site, selectedRoadmap, setSelectedRoadmaps }) => {
  const [expandedKeys, setExpandedKeys] = useState({});
  const menuItem: MenuItem[] = site.availableTargetGroupGroupedByStandardGrade.map((el, index) => ({
    key: index,
    template: <PanelMenuHeaderTemplate standardGradeNode={el} selectedRoadmaps={selectedRoadmap} />,
    items: el.targetGroup.map(tgItem => ({
      template: (
        <PanelMenuCheckboxTemplate
          selectedRoadmap={selectedRoadmap}
          setSelectedRoadmaps={setSelectedRoadmaps}
          targetGroup={tgItem}
          setExpandedKeys={setExpandedKeys}
        />
      ),
    })),
  }));

  return (
    <div className="w-full lg:w-5">
      <div className="flex flex-column gap-2">
        <h1 className="text-lg align-self-center">{site.name}</h1>
        <PanelMenu
          expandedKeys={expandedKeys}
          onExpandedKeysChange={setExpandedKeys}
          className="nc_panel-menu-roadmap nc_listbox-max-height"
          model={menuItem}
        />
      </div>
    </div>
  );
};

export default PanelMenuRoadmaps;
